import ObjectCache from './CacheService';
import UserAccount from '../UserAccount';
import TeamApi from '../server/TeamApi';
import Team from '../../models/team';

class TeamCache extends ObjectCache {
  api = TeamApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new Team(results.owner, results.company, results.users, UserAccount.account._id, results._id, results.longname, results.description, results.createdTime, results.updateTime, results.shareSetting);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  }
  getObjectJson = (_model) => _model.getJson();
}

const singleton = new TeamCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
